import './index.css';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import store from '@/store';

import { AuthInitializer } from './AuthInitializer';

const AudienceRecommendationInsightsPage = React.lazy(() => import('./pages/AudienceRecommendationInsightsPage'));
const HomePage = React.lazy(() => import('./pages/HomePage'));
const LogoutPage = React.lazy(() => import('./pages/LogoutPage'));

const renderApp = () => {
    createRoot(document.getElementById('root')).render(
        <StrictMode>
            <Provider store={store}>
                <BrowserRouter>
                    <AuthInitializer>
                        <Routes>
                            <Route path="/logout" element={<LogoutPage />} />
                            <Route
                                path="/audience-recommendation-insights/:recommendationId"
                                element={<AudienceRecommendationInsightsPage />}
                            />
                            <Route path="*" element={<HomePage />} />
                        </Routes>
                    </AuthInitializer>
                </BrowserRouter>
            </Provider>
        </StrictMode>,
    );
};

if (import.meta.env.VITE_USE_MSW === 'true') {
    const { worker } = await import('./mocks/msw/browser.js');
    await worker.start({ onUnhandledRequest: 'bypass' });
}

renderApp();
